import React, { PureComponent } from 'react';
import Box from '@mui/material/Box';

class FadeInSection extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { isVisible: false };
        this.domRef = React.createRef();
    }

    componentDidMount() {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    this.setState({ isVisible: true });
                    observer.unobserve(this.domRef.current);
                }
            },
            { threshold: 0.1 }
        );
        if (this.domRef.current) {
            observer.observe(this.domRef.current);
        }
        this._observer = observer;
    }

    componentWillUnmount() {
        if (this._observer) {
            this._observer.disconnect();
        }
    }

    render() {
        return (
            <Box
                ref={this.domRef}
                sx={{
                    opacity: this.state.isVisible ? 1 : 0,
                    transform: this.state.isVisible ? 'translateY(0)' : 'translateY(24px)',
                    transition: 'opacity 0.7s ease-out, transform 0.7s ease-out',
                }}
            >
                {this.props.children}
            </Box>
        );
    }
}

export default FadeInSection;
